import { getEventEmitter } from '@flixbus/transclusion-eventing';

export const EVENT_DATE_ARROW_CLICK = 'search.search-mask.departureDateArrow.clicked';

export const emitDateArrowClickEvent = (day: 'previous' | 'next') => {
  getEventEmitter().emit(EVENT_DATE_ARROW_CLICK, { day });
};
